import { useSearchParams } from "react-router-dom";
import {
  Card,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import {
  spacing,
  colors,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import ProfitOverTimeChart from "./ProfitOverTimeChart";
import { useTrackOpen } from "../../../../../helpers/hooks/useTrackOpen";

const ProfitOverTimeChartWrap = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const timeUnit = searchParams.get("timeUnitPMobile") || "day";
  const handleChange = (value: any) => {
    const updated = new URLSearchParams(searchParams);
    updated.set("timeUnitPMobile", value);
    setSearchParams(updated);
  };
  const trackOpen = useTrackOpen();
  return (
    <>
      <Card
        sx={{
          borderRadius: spacing.Radius.md.$value,
          boxShadow: 3,
          mb: spacing.Spacing.xl.$value,
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
          sx={{
            px: spacing.Spacing.xl.$value,
            pt: spacing.Spacing.xl.$value,
            pb: spacing.Spacing.none.$value,
          }}
        >
          <Typography
            color={colors.GrayLightMode[700].$value}
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
              fontWeight: typography.Font_weight.Medium.$value,
            }}
          >
            Profit over time
          </Typography>

          <FormControl size="small">
            <Select
              onOpen={() => trackOpen("711")}
              value={timeUnit}
              onChange={(e) => handleChange(e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: typography.Size.Text.sm.$value,
                      minHeight: spacing.Spacing["5xl"].$value,
                    },
                  },
                },
              }}
              sx={{
                borderRadius: 2,
                height: spacing.Spacing["4xl"].$value,
                minWidth: spacing.Spacing["9xl"].$value,
                maxWidth: spacing.Spacing["9xl"].$value,
                py: spacing.Spacing.sm.$value,
                px: spacing.Spacing.none.$value,
                fontSize: typography.Size.Text.sm.$value,
                lineHeight: typography.Line_height.text.sm.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                color: colors.GrayLightMode[700].$value,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "& .MuiSelect-icon": {
                  color: colors.GrayLightMode[700].$value,
                },
              }}
            >
              <MenuItem value="day">Day</MenuItem>
              <MenuItem value="week">Week</MenuItem>
              <MenuItem value="month">Month</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <ProfitOverTimeChart />
      </Card>
    </>
  );
};

export default ProfitOverTimeChartWrap;
